// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Route from "../Route.bs.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as TraitsList from "./TraitsList.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StatsConfig from "./StatsConfig.bs.js";
import * as StatsTable2 from "../components/StatsTable2.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as ListGridSelect from "./ListGridSelect.bs.js";
import * as InContextTraitOverview from "./InContextTraitOverview.bs.js";

var cols = [
  StatsTable2.col(false, undefined, (function (param, param$1) {
          return param$1.t("Trait");
        }), undefined, (function (param, param$1, param$2) {
          var setSelectedTrait = param$1.setSelectedTrait;
          var aperture = param$1.aperture;
          var router = param$1.router;
          var screenSize = param$1.screenSize;
          var match = param[0];
          var rank = match[1];
          var traitId = match[0];
          var set = TftSet.use(undefined);
          var c = Sd.traitRankUnitCount(traitId, rank, set);
          return React.createElement("div", {
                      className: "flex items-center h-full cursor-pointer",
                      onClick: (function (param) {
                          if (ScreenAtom.isMobile(screenSize)) {
                            return router.push(Route.toString({
                                            TAG: /* Stats */0,
                                            _0: {
                                              TAG: /* Trait */5,
                                              trait: traitId,
                                              rank: rank,
                                              aperture: aperture
                                            }
                                          }), undefined, undefined);
                          } else {
                            return Curry._1(setSelectedTrait, (function (param) {
                                          return [
                                                  traitId,
                                                  rank
                                                ];
                                        }));
                          }
                        })
                    }, React.createElement(StatsTable2.ExpandIcon.make, {
                          onClick: (function (param) {
                              
                            })
                        }), React.createElement(TraitTooltip.make, {
                          trait: traitId,
                          rank: rank,
                          children: React.createElement(TraitImage.PlainIcon.make, {
                                traitId: traitId,
                                rank: rank,
                                size: 24,
                                sizeSm: 28
                              })
                        }), React.createElement("div", {
                          className: "pl-[6px] truncate",
                          onClick: (function (param) {
                              if (ScreenAtom.isMobile(screenSize)) {
                                return router.push(Route.toString({
                                                TAG: /* Stats */0,
                                                _0: {
                                                  TAG: /* Trait */5,
                                                  trait: traitId,
                                                  rank: rank,
                                                  aperture: aperture
                                                }
                                              }), undefined, undefined);
                              } else {
                                return Curry._1(setSelectedTrait, (function (param) {
                                              return [
                                                      traitId,
                                                      rank
                                                    ];
                                            }));
                              }
                            })
                        }, String(c) + " ", React.createElement(TraitName0.make, {
                              trait: traitId
                            })));
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          var match = param[0];
          return param$2.traitsT(match[0]) + String(match[1]);
        }), undefined, 200, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Play rate");
        }), undefined, (function (param, param$1, param$2) {
          return (Global.f(param[1].count) / Global.f(param$1.totalEntries) * 8).toFixed(2) + " / 8";
        }), undefined, (function (param, param$1, param$2) {
          return T.humanReadableCount(param[1].count) + " games";
        }), undefined, (function (param, param$1, param$2) {
          return param[1].count;
        }), undefined, 108, undefined, undefined),
  StatsTable2.col(false, true, (function (param, param$1) {
          return param$1.t("Place");
        }), undefined, (function (param, param$1, param$2) {
          return param[1].place.toFixed(2);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].place;
        }), undefined, 85, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Top 4");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].top4);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].top4;
        }), undefined, 85, undefined, undefined),
  StatsTable2.col(undefined, true, (function (param, param$1) {
          return param$1.t("Win");
        }), undefined, (function (param, param$1, param$2) {
          return Global.formatPct3(param[1].won);
        }), undefined, undefined, undefined, (function (param, param$1, param$2) {
          return param[1].won;
        }), undefined, 71, undefined, undefined)
];

function TraitsPage$List(Props) {
  var stats = Props.stats;
  var setSelectedTrait = Props.setSelectedTrait;
  Translation.useT(/* Common */0);
  var set = TftSet.use(undefined);
  var match = React.useState(function () {
        return false;
      });
  var router = Router.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  var data = React.useMemo((function () {
          return Belt_Array.map(Js_dict.entries(stats.traits), (function (param) {
                        var s = param[0].split("__");
                        var trait = Belt_Array.getExn(s, 0);
                        var rank = Belt_Option.getExn(Belt_Int.fromString(Belt_Array.getExn(s, 1)));
                        return [
                                [
                                  trait,
                                  rank
                                ],
                                param[1]
                              ];
                      }));
        }), [stats]);
  var keyFn = React.useCallback((function (v) {
          return v[0][0] + String(v[0][1]);
        }), []);
  var context = React.useMemo((function () {
          return {
                  screenSize: screenSize,
                  router: router,
                  aperture: aperture,
                  setSelectedTrait: setSelectedTrait,
                  totalEntries: stats.totalEntries
                };
        }), [
        router,
        screenSize,
        stats,
        aperture,
        setSelectedTrait
      ]);
  var tableClass = match[0] ? "tbl-hide-cat1" : "";
  var rowClass = React.useCallback((function (param) {
          var match = param[0];
          if (Sd.traitStyle(match[0], match[1], set) === 4) {
            return "tbl-row-cat1";
          } else {
            return "";
          }
        }), []);
  return React.createElement("div", {
              className: "flex flex-col items-center text-sm md:text-base"
            }, React.createElement(ContentSection.make, {
                  className: "py-3 px-0",
                  children: React.createElement("div", {
                        className: tableClass
                      }, React.createElement(StatsTable2.make, {
                            cols: cols,
                            rowClass: rowClass,
                            data: data,
                            context: context,
                            keyFn: keyFn,
                            stickyColCount: 1,
                            defaultSortIdx: 1
                          }))
                }));
}

var List = {
  make: TraitsPage$List
};

function TraitsPage(Props) {
  var statsData = Props.statsData;
  var match = React.useState(function () {
        return true;
      });
  var isListMode = match[0];
  var match$1 = React.useState(function () {
        
      });
  var setSelectedTrait = match$1[1];
  var selectedTrait = match$1[0];
  var router = Router.use(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var aperture = ApertureCtx.useValue(undefined);
  return React.createElement(AdLayout.make, {
              children: null
            }, React.createElement(StatsConfig.make, {
                  children: React.createElement(ListGridSelect.make, {
                        isListMode: isListMode,
                        setIsListMode: match[1]
                      })
                }), React.createElement(StatsConfig.Context.make, {
                  children: null
                }, isListMode ? React.createElement(TraitsPage$List, {
                        stats: statsData,
                        setSelectedTrait: setSelectedTrait
                      }) : React.createElement(TraitsList.make, {
                        onTraitSelected: (function (traitId, rank) {
                            if (ScreenAtom.isMobile(screenSize)) {
                              return router.push(Route.toString({
                                              TAG: /* Stats */0,
                                              _0: {
                                                TAG: /* Trait */5,
                                                trait: traitId,
                                                rank: rank,
                                                aperture: aperture
                                              }
                                            }), undefined, undefined);
                            } else {
                              return Curry._1(setSelectedTrait, (function (param) {
                                            return [
                                                    traitId,
                                                    rank
                                                  ];
                                          }));
                            }
                          }),
                        stats: statsData.traits,
                        totalEntries: statsData.totalEntries
                      }), selectedTrait !== undefined ? React.createElement(InContextTraitOverview.make, {
                        rank: selectedTrait[1],
                        traitId: selectedTrait[0],
                        onClose: (function (param) {
                            return Curry._1(setSelectedTrait, (function (param) {
                                          
                                        }));
                          })
                      }) : null));
}

var make = TraitsPage;

export {
  cols ,
  List ,
  make ,
  
}
/* cols Not a pure module */
